import React from "react";
import PropTypes from "prop-types";
import ToolTip from "../shared/ToolTip/ToolTip";

const RenderAssumption = ({ assumption, tooltip, color = "#191919" }) => {
  let linkElement = assumption.link ? (
    <a target="new" href={assumption.link}>
      {assumption.valueAsFormatted}
    </a>
  ) : (
    assumption.valueAsFormatted.toString()
  );

  return (
    <p
      className="legal-disclaimer"
      style={{ fontSize: "12px", lineHeight: "15px" }}
    >
      {assumption.title}
      {tooltip && <ToolTip message={tooltip} id={"_tooltip"} />}
      <span style={{ float: "right",  color: color}}>{linkElement}</span>
    </p>
  );
};

export default RenderAssumption;

RenderAssumption.propTypes = {
  assumption: PropTypes.object,
};
